import React, { useCallback, useEffect, useRef, useState } from 'react';
import Input from './Input';

type TextareaProps = {
  scale: number;
  expand?: boolean;
  onFocus?: () => void;
} & React.ComponentPropsWithoutRef<typeof Input>;

const Textarea = ({ scale, onFocus, expand, ...rest }: TextareaProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [initialHeight, setInitialHeight] = useState<number | null>(null);

  const handleFocus = () => {
    onFocus && onFocus();
    handleExpand();
  };

  const handleExpand = useCallback(() => {
    const input = inputRef?.current;
    if (input && initialHeight) {
      input.style.height = initialHeight * scale + 'px';
    }
  }, [initialHeight, scale]);

  const handleContract = useCallback(() => {
    const input = inputRef?.current;
    if (input && initialHeight && !expand) {
      input.style.height = initialHeight + 'px';
    }
  }, [expand, initialHeight]);

  useEffect(() => {
    if (inputRef?.current) {
      const input = inputRef?.current;
      const height = input.offsetHeight;
      setInitialHeight(48);
      input.style.height = height + 'px';
      input.style.fontSize = '0.85rem';
    }
  }, []);

  useEffect(() => {
    if (expand) {
      handleExpand();
    } else {
      handleContract();
    }
  }, [expand, handleContract, handleExpand]);

  return (
    <Input
      as="textarea"
      ref={inputRef}
      onFocus={handleFocus}
      onBlur={handleContract}
      style={{ transition: 'height .3s ease' }}
      rows={1}
      {...rest}
    />
  );
};

export default Textarea;
